import {cva} from 'class-variance-authority';

import {cn} from '../../lib/utils';
import {Icon} from '../Icon/Icon';

import type {ModalIconVariant} from './modal.types';
import type {IconName} from '../../icons/icon-map';

export const modalIconVariantsConfig = {
  variants: {
    variant: {
      brand: 'bg-brand-primary/10 text-brand-primary',
      destructive: 'bg-destructive/10 text-destructive',
      info: 'bg-background-info text-text-info'
    }
  },
  defaultVariants: {
    variant: 'brand'
  }
} as const;

export const modalIconVariants = cva(
  'flex size-12 shrink-0 items-center justify-center rounded-full [&_svg]:size-6',
  modalIconVariantsConfig
);

export interface ModalIconProps {
  icon: IconName;
  variant?: ModalIconVariant;
  className?: string;
}

export function ModalIcon({icon, variant = 'brand', className}: ModalIconProps) {
  return (
    <div data-slot="modal-icon" className={cn(modalIconVariants({variant}), className)}>
      <Icon name={icon} />
    </div>
  );
}
